export const CALCULATOR_DATA_GA = {
  calculator: 'calculator',
  calculatorClick: 'calculator-click',
};

export const CALCULATOR_DATA_TEST = {
  calculator: 'section-calculator',
};
